import { render, staticRenderFns } from "./UserListTable.vue?vue&type=template&id=b501f1e8&"
import script from "./UserListTable.vue?vue&type=script&lang=js&"
export * from "./UserListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1983107846/src/bitbucket.org/atsuboi/chatbot/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b501f1e8')) {
      api.createRecord('b501f1e8', component.options)
    } else {
      api.reload('b501f1e8', component.options)
    }
    module.hot.accept("./UserListTable.vue?vue&type=template&id=b501f1e8&", function () {
      api.rerender('b501f1e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Segment/Components/UserListTable.vue"
export default component.exports